import { observer } from 'mobx-react-lite'
import { InstructorSlideDeckPage } from './InstructorSlideDeckPage'
import { useRouter } from 'hooks/router'
import { useCubitBuilder } from 'hooks/cubits'
import { SlideDeckReviewCubit } from '@breakoutlearning/firebase-repository/cubits/SlideDeckReviewCubit'
import { useRepository } from 'hooks/auth'
import { useBreakoutUser } from 'hooks/profile'
import { FullPageSpinner } from 'components/Spinner'
import { useTranslationTyped } from 'i18n/i18n'
import { useRootStore } from 'hooks/rootStore'
import { toast } from 'react-hot-toast'

export const SlideDeckReview = observer(function SlideDeckReview() {
  const repository = useRepository()
  const router = useRouter()
  const { isInternal } = useBreakoutUser()
  const slideDeckId = (router.params?.slideDeckId ?? '') as string
  const { tt } = useTranslationTyped()
  const store = useRootStore()

  const cubit = useCubitBuilder(
    () =>
      new SlideDeckReviewCubit(repository, {
        isInternalUser: isInternal,
        slideDeckId,
      }),
    [repository, isInternal, slideDeckId]
  )

  const { canUserReviewSlideDeck } = cubit

  if (canUserReviewSlideDeck.loading) return <FullPageSpinner />

  if (!canUserReviewSlideDeck.canView) {
    const { reason } = canUserReviewSlideDeck
    if (reason === 'unauthorized')
      toast.error(tt.slide_deck_review.unauthorized())
    if (reason === 'internal')
      toast.error(tt.slide_deck_review.experience_not_configured())
    store.navigateTo('home')
    return null
  }

  if (!slideDeckId) return null

  return <InstructorSlideDeckPage slideDeckId={slideDeckId} />
})
